module.exports = __webpack_public_path__ + "img/77.7ca717e2.jpg";